import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import RadioGroup from "../../../RadioGroup/RadioGroup"
import MultiSelectDropdown from "../../../MultiSelectDropdown/MultiSelectDropdown"
import SearchInputV2 from "../../../SearchInputV2/SearchInputV2"
import FileUploader from "../../../../pages/Projects/features/RaiseTicketForm/common/FileUploader/FileUploader"
import { useFormContext } from "../../../../pages/Projects/features/RaiseTicketForm/FormContextProvider"
import { getLinkedSurveyIds } from "../../../../pages/Projects/ProjectSlice"
import { FormPageProps } from "../.."

import error_mark from "../../../../assets/images/error_mark.svg"
import styles from "../../RaiseTicketForm.module.scss"

const Infra = (props: FormPageProps) => {
    const dispatch = useDispatch()
    const {
        otherDetailsSetter,
        getOtherDetailsValue,
        getDealDetailsValue,
        showError,
        freezeField,
        setSurveyTicketLinked,
        currentStepDetail,
        handleFileUpload,
    } = useFormContext()
    const { ScopeStatusData } = useSelector((store: any) => store.operation)
    const { LinkedSurveyIds } = useSelector((state: any) => state.Projects)
    const INSTALLATION_FLAG = true //SOW includes infra

    useEffect(() => {
        dispatch(getLinkedSurveyIds())
    }, [])

    return (
        <>
            <div className={styles.page_container} style={{ maxHeight: 500, overflow: "auto" }}>
                <div className={styles.page_section}>
                    <div className={styles.form_section}>
                        <div
                            className={styles.section_header}
                            style={{ opacity: freezeField("is_location_fixed") ? "0.5" : "1" }}
                        >
                            Are chargers' spot fixed?*{" "}
                            {showError && !getOtherDetailsValue("is_location_fixed")?.title && (
                                <img src={error_mark} alt="" />
                            )}
                        </div>
                        <div className={styles.section_body}>
                            <div style={{ marginBottom: "10px" }}>
                                <RadioGroup
                                    options={[
                                        { id: 1, title: "Yes" },
                                        { id: 0, title: "No" },
                                    ]}
                                    onSelect={(value: any) => {
                                        otherDetailsSetter("is_location_fixed", value)
                                    }}
                                    value={getOtherDetailsValue("is_location_fixed")}
                                    disabled={freezeField("is_location_fixed")}
                                />
                            </div>
                        </div>
                        <div className={`${styles.form_section} flex gap-20`}>
                            <div className="width-100p">
                                <div
                                    className={styles.section_header}
                                    style={{ opacity: freezeField("no_of_charger_spots") ? "0.5" : "1" }}
                                >
                                    Number of Spots*
                                </div>
                                <SearchInputV2
                                    fontsize="12px"
                                    placeholder={"Enter No. Of Spots"}
                                    searchIcon={false}
                                    onSearch={(value: string) => {
                                        otherDetailsSetter("no_of_charger_spots", value)
                                    }}
                                    value={getOtherDetailsValue("no_of_charger_spots")}
                                    type="number"
                                    height="44px"
                                    additionalValidation="4"
                                    error={
                                        getOtherDetailsValue("is_location_fixed")?.title === "Yes" &&
                                        !getOtherDetailsValue("no_of_charger_spots")
                                    }
                                    showError={showError}
                                    disabled={freezeField("no_of_charger_spots")}
                                />
                            </div>
                            <div className="width-100p">
                                <div
                                    className={styles.section_header}
                                    style={{ opacity: freezeField("spot_image") ? "0.5" : "1" }}
                                >
                                    Spot Images*
                                </div>
                                <FileUploader
                                    name="spot_image"
                                    ticket_id={currentStepDetail?.ops_ticket_id}
                                    size="lg"
                                    accept="image/png,image/jpeg"
                                    onChange={e => {
                                        otherDetailsSetter("spot_image", e)
                                    }}
                                    onUpload={fileInfo => handleFileUpload(fileInfo)}
                                    title="Upload Images"
                                    total={getOtherDetailsValue("no_of_charger_spots") || 1}
                                    uploadedCount={
                                        typeof getOtherDetailsValue("spot_image") === "object"
                                            ? getOtherDetailsValue("spot_image")?.length
                                            : getOtherDetailsValue("spot_image")
                                              ? 1
                                              : ""
                                    }
                                    multiple={true}
                                    disabled={freezeField("spot_image")}
                                />
                            </div>
                        </div>
                    </div>
                    {INSTALLATION_FLAG && (
                        <>
                            <div className={`${styles.form_section} flex gap-20`}>
                                <div className="width-100p">
                                    <div
                                        className={styles.section_header}
                                        style={{ opacity: freezeField("survey_id") ? "0.5" : "1" }}
                                    >
                                        Link Survey Ticket ID
                                    </div>
                                    <div className={styles.section_body}>
                                        <MultiSelectDropdown
                                            fontsize="12px"
                                            title="Select Survey Ticket ID"
                                            options={LinkedSurveyIds?.map((item: any) => {
                                                return { id: item?.id, title: item?.name }
                                            })}
                                            id="Teams"
                                            onChange={() => {}}
                                            selectedOptions={
                                                getOtherDetailsValue("survey_id")?.id
                                                    ? [getOtherDetailsValue("survey_id")]
                                                    : []
                                            }
                                            onSelect={(value: any) => {
                                                setSurveyTicketLinked(true)
                                                otherDetailsSetter("survey_id", value)
                                            }}
                                            height="44px"
                                            selectionType="single"
                                            disabled={freezeField("survey_id")}
                                        />
                                    </div>
                                </div>
                                <div className="width-100p"></div>
                            </div>
                            <div className={`${styles.form_section} flex gap-20`}>
                                <div className="width-100p">
                                    <div
                                        className={styles.section_header}
                                        style={{ opacity: freezeField("scope_of_work") ? "0.5" : "1" }}
                                    >
                                        Infra Scope of Work*{" "}
                                        {showError &&
                                            INSTALLATION_FLAG &&
                                            !getOtherDetailsValue("scope_of_work")?.title && (
                                                <img src={error_mark} alt="" />
                                            )}
                                    </div>
                                    <div className={styles.section_body}>
                                        <div>
                                            <RadioGroup
                                                options={[
                                                    { id: 0, title: "Statiq" },
                                                    { id: 1, title: "Third Party" },
                                                ]}
                                                onSelect={(value: any) => {
                                                    otherDetailsSetter("scope_of_work", value)
                                                }}
                                                labelsStyle={{ display: "grid", gridTemplateColumns: "35% 40%" }}
                                                value={getOtherDetailsValue("scope_of_work")}
                                                disabled={freezeField("scope_of_work")}
                                            />
                                            {getOtherDetailsValue("scope_of_work")?.title === "Third Party" && (
                                                <div className={styles.form_section}>
                                                    <div className={styles.section_body}>
                                                        <MultiSelectDropdown
                                                            fontsize="12px"
                                                            title="Select Services"
                                                            options={
                                                                ScopeStatusData
                                                                    ? ScopeStatusData?.map((item: any) => {
                                                                          return { id: item?.id, title: item?.name }
                                                                      })
                                                                    : []
                                                            }
                                                            id="services"
                                                            onChange={() => {}}
                                                            selectedOptions={
                                                                getOtherDetailsValue("sow_group_ids")?.length
                                                                    ? [...getOtherDetailsValue("sow_group_ids")]
                                                                    : []
                                                            }
                                                            onSelect={(value: any) => {
                                                                otherDetailsSetter("sow_group_ids", value)
                                                            }}
                                                            height="44px"
                                                            error={!getOtherDetailsValue("sow_group_ids")?.length}
                                                            showError={showError}
                                                            disabled={freezeField("sow_group_ids")}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {INSTALLATION_FLAG && (
                                    <>
                                        <div className="width-100p">
                                            <div
                                                className={styles.section_header}
                                                style={{ opacity: freezeField("property_type") ? "0.5" : "1" }}
                                            >
                                                Type of property *{" "}
                                                {showError &&
                                                    INSTALLATION_FLAG &&
                                                    !getOtherDetailsValue("property_type")?.title && (
                                                        <img src={error_mark} alt="" />
                                                    )}
                                            </div>
                                            <div className={styles.section_body}>
                                                <div>
                                                    <RadioGroup
                                                        options={[
                                                            { id: "0", title: "Rented" },
                                                            { id: "1", title: "Owned/Self" },
                                                        ]}
                                                        onSelect={(value: any) => {
                                                            otherDetailsSetter("property_type", value)
                                                        }}
                                                        labelsStyle={{
                                                            display: "grid",
                                                            gridTemplateColumns: "35% 40%",
                                                        }}
                                                        value={getOtherDetailsValue("property_type")}
                                                        disabled={freezeField("property_type")}
                                                    />
                                                    {getOtherDetailsValue("property_type")?.title === "Rented" && (
                                                        <div className={styles.section_body}>
                                                            <FileUploader
                                                                name="rent_agreement"
                                                                ticket_id={currentStepDetail?.ops_ticket_id}
                                                                size="lg"
                                                                onChange={e => {
                                                                    otherDetailsSetter("rent_agreement", e)
                                                                }}
                                                                onUpload={fileInfo => handleFileUpload(fileInfo)}
                                                                title="Upload Rental Agreement"
                                                                total={1}
                                                                uploadedCount={
                                                                    typeof getOtherDetailsValue("rent_agreement") ===
                                                                    "object"
                                                                        ? getOtherDetailsValue("rent_agreement")?.length
                                                                        : getOtherDetailsValue("rent_agreement")
                                                                          ? 1
                                                                          : ""
                                                                }
                                                                error={!getOtherDetailsValue("rent_agreement")?.length}
                                                                showError={showError}
                                                                disabled={freezeField("rent_agreement")}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className={`${styles.form_section} flex gap-20`}>
                                <div className="width-100p">
                                    <div
                                        className={styles.section_header}
                                        style={{ opacity: freezeField("dg_present") ? "0.5" : "1" }}
                                    >
                                        Is DG connection also used?*{" "}
                                        {showError &&
                                            INSTALLATION_FLAG &&
                                            getOtherDetailsValue("is_ev_application_req")?.title === "Yes" &&
                                            !getOtherDetailsValue("dg_present")?.title && (
                                                <img src={error_mark} alt="" />
                                            )}
                                    </div>
                                    <div className={styles.section_body}>
                                        <div>
                                            <RadioGroup
                                                options={[
                                                    { id: 1, title: "Yes" },
                                                    { id: 0, title: "No" },
                                                ]}
                                                onSelect={(value: any) => {
                                                    otherDetailsSetter("dg_present", value)
                                                }}
                                                labelsStyle={{ display: "grid", gridTemplateColumns: "35% 40%" }}
                                                value={getOtherDetailsValue("dg_present")}
                                                disabled={freezeField("dg_present")}
                                            />
                                            {getOtherDetailsValue("dg_present")?.title === "Yes" && (
                                                <div
                                                    className={styles.section_body}
                                                    style={{ width: "50%", marginTop: 20 }}
                                                >
                                                    <div
                                                        className={styles.section_header}
                                                        style={{ opacity: freezeField("dg_unit_rate") ? "0.5" : "1" }}
                                                    >
                                                        DG Unit Rate*
                                                    </div>
                                                    <SearchInputV2
                                                        fontsize="12px"
                                                        placeholder={"Enter DG Unit Rate"}
                                                        searchIcon={false}
                                                        onSearch={(value: string) => {
                                                            otherDetailsSetter("dg_unit_rate", value)
                                                        }}
                                                        value={getOtherDetailsValue("dg_unit_rate")}
                                                        type="number"
                                                        height="44px"
                                                        error={!getOtherDetailsValue("dg_unit_rate")}
                                                        showError={showError}
                                                        disabled={freezeField("dg_unit_rate")}
                                                        // maxCharacter={field?.validation === "phone" ? 10 : field?.validation === "gst" ? 15 : ""}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="width-100p">
                                    <div
                                        className={styles.section_header}
                                        style={{ opacity: freezeField("access_type") ? "0.5" : "1" }}
                                    >
                                        Access Type*{" "}
                                        {showError &&
                                            INSTALLATION_FLAG &&
                                            !getOtherDetailsValue("access_type")?.title && (
                                                <img src={error_mark} alt="" />
                                            )}
                                    </div>
                                    <div className={styles.section_body}>
                                        <div>
                                            <RadioGroup
                                                options={[
                                                    { id: "0", title: "Public" },
                                                    { id: "1", title: "Captive" },
                                                ]}
                                                onSelect={(value: any) => {
                                                    otherDetailsSetter("access_type", value)
                                                }}
                                                value={getOtherDetailsValue("access_type")}
                                                disabled={freezeField("access_type")}
                                                labelsStyle={{ display: "grid", gridTemplateColumns: "35% 40%" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.form_title}>EV APPLICATION</div>

                            <div className={styles.form_section}>
                                <div className="width-100p">
                                    <div
                                        className={styles.section_header}
                                        style={{
                                            opacity: freezeField("is_ev_application_req") ? "0.5" : "1",
                                        }}
                                    >
                                        Is EVA Required*{" "}
                                        {showError &&
                                            INSTALLATION_FLAG &&
                                            !getOtherDetailsValue("is_ev_application_req")?.title && (
                                                <img src={error_mark} alt="" />
                                            )}
                                    </div>
                                    <div className={styles.section_body}>
                                        <div>
                                            <RadioGroup
                                                options={[
                                                    { id: 1, title: "Yes" },
                                                    { id: 0, title: "No" },
                                                ]}
                                                onSelect={(value: any) => {
                                                    otherDetailsSetter("is_ev_application_req", value)
                                                }}
                                                value={getOtherDetailsValue("is_ev_application_req")}
                                                disabled={freezeField("is_ev_application_req")}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {getOtherDetailsValue("is_ev_application_req")?.title === "Yes" && (
                                <div className={styles.form_section}>
                                    <div
                                        className={styles.section_header}
                                        style={{
                                            opacity: freezeField("ev_connection_owner") ? "0.5" : "1",
                                        }}
                                    >
                                        EV Connection owned by*{" "}
                                        {showError &&
                                            INSTALLATION_FLAG &&
                                            !getOtherDetailsValue("ev_connection_owner")?.title && (
                                                <img src={error_mark} alt="" />
                                            )}
                                    </div>
                                    <div className={styles.section_body}>
                                        <div>
                                            <RadioGroup
                                                options={[
                                                    { id: 0, title: "Host" },
                                                    { id: 1, title: "Statiq" },
                                                    { id: 2, title: "Third Party" },
                                                ]}
                                                onSelect={(value: any) => {
                                                    otherDetailsSetter("ev_connection_owner", value)
                                                }}
                                                value={getOtherDetailsValue("ev_connection_owner")}
                                                disabled={freezeField("ev_connection_owner")}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
                <div className={styles.form_section}>
                    <div className={styles.section_body}>
                        <div className={styles.sub_section}>
                            <div style={{ width: "100%" }}>
                                <div className={styles.section_header}>Upload Electricity Bill*</div>
                                <FileUploader
                                    name="electricity_bill"
                                    ticket_id={currentStepDetail?.ops_ticket_id}
                                    size="lg"
                                    onChange={e => {
                                        otherDetailsSetter("electricity_bill", e)
                                    }}
                                    onUpload={fileInfo => handleFileUpload(fileInfo)}
                                    title="Upload File"
                                    total={1}
                                    uploadedCount={
                                        typeof getOtherDetailsValue("electricity_bill") === "object"
                                            ? getOtherDetailsValue("electricity_bill")?.length
                                            : getOtherDetailsValue("electricity_bill")
                                              ? 1
                                              : ""
                                    }
                                    error={
                                        !getOtherDetailsValue("electricity_bill")?.length &&
                                        getOtherDetailsValue("is_ev_application_req")?.title !== "Yes"
                                    }
                                    showError={showError}
                                />
                            </div>
                            {getOtherDetailsValue("is_ev_application_req")?.title === "Yes" ? (
                                <div style={{ width: "100%" }}>
                                    <div
                                        className={styles.section_header}
                                        style={{
                                            opacity: freezeField("evc_affidavit") ? "0.5" : "1",
                                        }}
                                    >
                                        Upload Affidavit*
                                    </div>
                                    <FileUploader
                                        name="evc_affidavit"
                                        ticket_id={currentStepDetail?.ops_ticket_id}
                                        size="lg"
                                        onChange={e => {
                                            otherDetailsSetter("evc_affidavit", e)
                                        }}
                                        onUpload={fileInfo => handleFileUpload(fileInfo)}
                                        title="Upload File"
                                        total={1}
                                        uploadedCount={
                                            typeof getOtherDetailsValue("evc_affidavit") === "object"
                                                ? getOtherDetailsValue("evc_affidavit")?.length
                                                : getOtherDetailsValue("evc_affidavit")
                                                  ? 1
                                                  : ""
                                        }
                                        error={
                                            !getOtherDetailsValue("evc_affidavit")?.length &&
                                            getOtherDetailsValue("is_ev_application_req")?.title !== "No"
                                        }
                                        showError={showError}
                                        disabled={freezeField("evc_affidavit")}
                                    />
                                </div>
                            ) : getOtherDetailsValue("is_ev_application_req")?.title === "No" ? (
                                getDealDetailsValue("deal_scope_of_work")?.some((i: any) => i.id === 3) && (
                                    <div style={{ width: "100%" }}>
                                        <div className={styles.section_header}>Fixed Electricity Charge*</div>
                                        <div className={styles.section_body}>
                                            <SearchInputV2
                                                fontsize="12px"
                                                placeholder={"Enter Fixed Electricity Charge"}
                                                searchIcon={false}
                                                onSearch={(value: string) => {
                                                    otherDetailsSetter("fixed_electricity_charge", value)
                                                }}
                                                value={getOtherDetailsValue("fixed_electricity_charge")}
                                                type="number"
                                                height="44px"
                                                showError={
                                                    showError && getOtherDetailsValue("fixed_electricity_charge") !== 0
                                                }
                                                error={!getOtherDetailsValue("fixed_electricity_charge")}
                                            />
                                        </div>
                                    </div>
                                )
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>
                </div>

                {getOtherDetailsValue("is_ev_application_req")?.title === "No" && (
                    <div className={`${styles.form_section} flex gap-20`}>
                        <div className="width-100p">
                            <div
                                className={styles.section_header}
                                style={{ opacity: freezeField("per_unit_price") ? "0.5" : "1" }}
                            >
                                Per Unit Rate{" "}
                                {getOtherDetailsValue("is_ev_application_req")?.title === "No" ? "(Host)" : ""}
                            </div>
                            <div className={styles.section_body}>
                                <SearchInputV2
                                    fontsize="12px"
                                    placeholder={"Enter Rate"}
                                    searchIcon={false}
                                    onSearch={(value: string) => {
                                        otherDetailsSetter("per_unit_price", value)
                                    }}
                                    value={getOtherDetailsValue("per_unit_price")}
                                    type="number"
                                    height="44px"
                                    error={!getOtherDetailsValue("per_unit_price")}
                                    disabled={freezeField("per_unit_price")}
                                />
                            </div>
                        </div>
                        <div className="width-100p">
                            <div
                                className={styles.section_header}
                                style={{
                                    opacity: freezeField("sanctioned_load") ? "0.5" : "1",
                                }}
                            >
                                Sanctioned Load (In KWH)
                            </div>
                            <div className={styles.section_body}>
                                <SearchInputV2
                                    fontsize="12px"
                                    placeholder={"Enter Sanctioned Load"}
                                    searchIcon={false}
                                    onSearch={(value: string) => {
                                        otherDetailsSetter("sanctioned_load", value)
                                    }}
                                    value={getOtherDetailsValue("sanctioned_load")}
                                    type="number"
                                    height="44px"
                                    error={!getOtherDetailsValue("sanctioned_load")}
                                    disabled={freezeField("sanctioned_load")}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <footer className="raise-ticket-form__footer">
                <button className="raise-ticket-form__footer-button cancel-btn" onClick={props?.handleCloseForm}>
                    Cancel
                </button>
                <button className="raise-ticket-form__footer-button next-btn" onClick={props?.handleNextStep}>
                    Next
                </button>
            </footer>
        </>
    )
}

export default Infra
